import { render, staticRenderFns } from "./ContentNavWrapper.vue?vue&type=template&id=3251f71b&scoped=true&"
import script from "./ContentNavWrapper.vue?vue&type=script&lang=js&"
export * from "./ContentNavWrapper.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3251f71b",
  null
  
)

export default component.exports